import React from "react";
import TrackVisibility from "react-on-screen";
import CountUp from "react-countup";

const CounterOne = ({ phone, data, services }) => {
  const formatPhoneNumber = (number) => {
    // Remove non-numeric characters
    return number.replace(/[^\d]/g, "");
  };
  // Format the phone number
  const formattedNumber = formatPhoneNumber(phone);
  console.log(phone);
  // Generate the WhatsApp URL
  console.log(formattedNumber);
  const whatsappURL = `https://wa.me/1${formattedNumber}`;
  return (
    <div className="counter-area-1 space-bottom">
      <div className="container">
        <div className="counter-wrap1">
          <div className="row gx-0 align-items-center">
            <div className="col-lg-12">
              <div
                className="counter-checklist-wrap"
                style={{
                  backgroundImage: `url('${
                    data.main_image
                      ? data.main_image
                      : "assets/img/hero/Image_3.png"
                  }')`,
                }}
              >
                <div className="checklist style-white mb-50">
                <ul>
  {services.map((service, index) => (
    <li key={index}>
      <i className="fas fa-check" />
      <span dangerouslySetInnerHTML={{ __html: service.text }} />
    </li>
  ))}
</ul>

                </div>
                <div className="call-media-wrap">
                  <div className="icon">
                    <img src="assets/img/icon/phone-1.svg" alt="Fixturbo" />
                  </div>
                  <div className="media-body">
                    <h6 className="title text-white">Requesting A Call:</h6>
                    <h4 className="link">
                      <a
                        className="text-white"
                        href={whatsappURL}
                        target="_blank"
                      >
                        {phone}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterOne;
